import PropTypes from 'prop-types';
import { memo } from 'react';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import Track from '../../tracking/ZorseTicketInspectorTracker';
import { jsx as _jsx } from "react/jsx-runtime";
function DialogCloseButton(props) {
  return /*#__PURE__*/_jsx(UIDialogCloseButton, {
    "data-test-id": "dialog-close-button-internal",
    onClick: () => {
      Track.filtersClosed();
      props.onClick();
    }
  });
}
DialogCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(DialogCloseButton);